import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-leaderboard-information-modal',
  templateUrl: './leaderboard-information-modal.component.html',
  styleUrls: ['./leaderboard-information-modal.component.css']
})
export class LeaderboardInformationModalComponent implements OnInit {

  ispopUpShow: boolean = false;
  @Output() modelOpen = new EventEmitter<boolean>();
  @Input() desc;

  constructor() { }

  ngOnInit(): void {
  }

  closePop() {
    this.modelOpen.emit(false);
  }

}
